<template>
  <div class="data-owner">
    <el-breadcrumb class="admin-path" separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>数据维护</el-breadcrumb-item>
      <el-breadcrumb-item>OWNER数据维护</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="container">
      <el-form :inline="true" :model="searchParams" class="search-form">
        <el-form-item label="Owner ID">
          <el-input size="mini"  v-model="searchParams.owner_id"></el-input>
        </el-form-item> 

        <!-- <el-form-item label="是否公开">
          <el-checkbox size='mini' v-model="checkedisopen"></el-checkbox>
        </el-form-item> -->
        <el-form-item>
          <el-button size='mini' type="primary" @click="onSubmit">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button size='mini'  @click="ownerinsert">新增</el-button>
        </el-form-item>
      </el-form>
      <!-- <div>
        <el-button
              class="download-all"
              type="text"
              size="small">
              批量下载
        </el-button>
        <el-button
              class="apply-all"
              type="text"
              size="small">
              批量申请
        </el-button>
      </div> -->
      <el-table
        :data="list"
        style="width: 100%">
        <el-table-column
          type="selection"
          width="55">
        </el-table-column>
        <el-table-column
          prop="owner_id"
          label="owner_id">
        </el-table-column>
        <el-table-column
          prop="type"
          label="类别">
        </el-table-column>
        <el-table-column
          prop="user_id"
          label="用户ID">
        </el-table-column>
        <el-table-column
          prop="name"
          label="姓名">
        </el-table-column>
        <el-table-column
          prop="email"
          label="邮箱列表">
        </el-table-column>
    
        <el-table-column
          width="150"
          label="操作">
          <template slot="header" slot-scope="">
            <!-- <el-button
              class="download-all"
              type="text"
              size="small">
              批量下载
            </el-button>
            <el-button
              class="apply-all"
              type="text"
              size="small">
              批量申请
            </el-button> -->
          </template>
          <template slot-scope="scope">

            <!-- <el-link type="primary" :href="`/download/${scope.row.idai}`" target="_blank">下载</el-link> -->

            <el-button
              class="copy-btn"
              :data-clipboard-text="scope.row"
              type="text"
              size="small"
              @click="ownerEdit(scope.row)">
              编辑
            </el-button>

            <el-button
              class="copy-btn"
              :data-clipboard-text="scope.row.owner_id"
              type="text"
              size="small"
              @click="ownerDelete(scope.row.owner_id)">
              删除
            </el-button>

          
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        background
        layout="total, sizes, prev, pager, next, jumper"
        :current-page.sync="currentPage"
        :page-size.sync="pageSize"
        :total="total"
        @size-change="sizeChange"
        @current-change="changePage">
      </el-pagination>

      <el-dialog title="Owner新增" :visible.sync="ownerIsVisible" @close="closeownerInsertDialog">
        <el-form :model="ownerForm" label-position="right">
          <el-form-item label="Owner ID">
            <el-input v-model="ownerForm.owner_id" autocomplete="off" ></el-input>
          </el-form-item>
          <el-form-item label="类别">
            <el-input v-model="ownerForm.type" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="姓名">
            <el-input v-model="ownerForm.name" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="邮件地址">
            <el-input v-model="ownerForm.email" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="用户ID">
            <el-input v-model="ownerForm.user_id" autocomplete="off"></el-input>
          </el-form-item>          
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="closeownerInsertDialog">取消</el-button>
          <el-button type="primary" @click="confirmOwnerInsertDialog">确定</el-button>
        </div>
      </el-dialog>

      <OwnerEditDialog
        :dialog-visible="OwnerEditIsVisible"
        :dialog-data="currentDataId"
        @ok="confirmOwnerEditDialog"
        @close="closeOwnerEditDialog">
      </OwnerEditDialog>
    </div>
  </div>
</template>

<script>
import {AuthStates} from '../common';
import axios from 'axios';
import OwnerEditDialog from './OwnerEditDialog.vue';

export default {
  name: 'DataOwner',
  components: {
    OwnerEditDialog,
  },
  data() {
    return {
      searchParams: {
        owner_id:'',
      },
      list: [],
      currentPage: 1,
      pageSize: 20,
      total: 0,
      checkedisopen:false,
      // checkedisstate:false,
      authstates: AuthStates,
      currentastates: '',
      ownerIsVisible: false,
      ownerForm: {
        owner_id:'',
        type:'',
        name: '',
        email: '', 
        user_id:'',      
      },
      //修改窗口：参数
      OwnerEditIsVisible:false,
      currentDataId: null,

    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      const params = {
        currentPage: this.currentPage,
        pageSize: this.pageSize,
        datastatus: this.currentastates,
        dataproc: this.checkedisstate,
        ...this.searchParams,
      }
      axios.post('/iapi/DataOwner', params).then((res) => {
        if (res.data.errcode === 0) {
          this.total = res.data.data.total;
          this.list = res.data.data.list;
        }
      });
      // console.log("authstates",this.currentastates);
    },
    sizeChange() {
      this.getData();
    },
    onSubmit() {
      this.currentPage = 1;
      this.getData();
    },
    ownerinsert(){
      this.ownerIsVisible = true;
      this.ownerForm.owner_id = '';
      this.ownerForm.type = '';
      this.ownerForm.name = '';
      this.ownerForm.email = '';
      this.ownerForm.user_id = '';
    },
    
    closeownerInsertDialog(){
      this.ownerIsVisible = false;
    },
    confirmOwnerInsertDialog(){
      this.closeownerInsertDialog();
      const params = {
        ...this.ownerForm,
      };
      axios.post('/iapi/ownerinsert', params).then((res) => {
        if (res.data.errcode === 0) {
          this.$message('新增Owner数据成功！');
        }
      });
      this.getData();
    },
    ownerEdit(dataId) {
      this.currentDataId =  dataId;
      this.OwnerEditIsVisible = true;     
    },
    confirmOwnerEditDialog(data){
      // console.log('编辑确定在这里', data);
      this.closeOwnerEditDialog();
      const params = {
        name:data.name,
        owner_id:data.owner_id,
        user_id:data.user_id,
        email:data.email,
        type:data.type,
      }
      axios.post('/iapi/owneredit', params).then((res) => {
        if (res.data.errcode === 0) {
          this.$message('编辑Owner信息成功！');
        }
      });
      this.getData();

    },
    closeOwnerEditDialog(){
      this.OwnerEditIsVisible = false;
    },
    ownerDelete(dataId) {
      const params = {
        data_id: dataId,
      };
      axios.post('/iapi/ownerdelete', params).then((res) => {
        if (res.data.errcode === 0) {
          this.$message('删除Owner信息成功');
        }
      });
      this.getData();
    },
    changePage(page) {
      this.currentPage = page;
      this.getData();
    },
  },
};
</script>

<style scoped>
.data-owner {
  padding: 24px 56px;
}
.container {
  background: #fff;
  border-radius: 2px;
}
.search-form {
  padding-left: 16px;
  padding-right: 16px;
  padding-top: 8px;
  padding-bottom: 8px;
}
.el-form-item {
    color: blue;
    margin-top: 0px;
    margin-bottom: 0px;
}
.admin-path {
  margin-bottom: 16px;
}
</style>